<template>
  <BadgeInfoModal
    v-if="badge"
    :key="notice?.id"
    :badge="badge"
    :image="image"
    :praise="praise"
    @close="close"
  />
  <!-- Принудительное уведомление: ни крестика, ни закрытия по подложке и
       Escape — единственный выход отсюда кнопка, она же подтверждает
       прочтение. -->
  <BaseModal
    v-else-if="notice"
    :open="true"
    :title="notice.title"
    :closable="false"
    size="sm"
    :z-index="10001"
  >
    <div class="forced-notice">
      <h2>{{ notice.title }}</h2>
      <div v-html="notice.html" />
      <button type="button" @click="close">{{ t('vpn.badges.modal.close') }}</button>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseModal from '@/shared/components/base/BaseModal.vue'
import BadgeInfoModal from '@/modules/vpn/components/BadgeInfoModal.vue'
import type { VpnBadge } from '@/modules/vpn/types/badges'
import { stripHtml } from '../api/notificationsApi'
import { useNotificationsStore } from '../store/notificationsStore'

const store = useNotificationsStore()
const { t } = useI18n()
const notice = computed(() => store.forcedItems[0] ?? null)
const images = import.meta.glob<string>('../../../assets/images/badges/*.webp', { eager: true, import: 'default' })
const image = computed(() => images[`../../../assets/images/badges/${notice.value?.badgeCode}.webp`] ?? '')
const badge = computed<VpnBadge | null>(() => {
  const item = notice.value
  if (!item?.badgeCode || !image.value) return null
  return {
    code: item.badgeCode,
    title: item.title,
    collection: item.badgeCode.startsWith('vpn_rank_') ? 'league' : 'path',
    earned: true,
    earnedAt: item.earnedAt ?? null,
  }
})

/**
 * IGRA-409 — поздравление с наградой. Приходит телом строки уведомления с
 * бэкенда (реестр `config/badges.php`, поле `praise`), потому что тем же
 * текстом награда уходит в телеграм. Разметки в нём нет, но тело уведомления в
 * принципе HTML — поэтому теги снимаем, а не доверяем.
 */
const praise = computed(() => stripHtml(notice.value?.html ?? ''))

// Fetch never acknowledges: only closing a rendered notice does. Same read API
// and same items as the bell, not a second inbox or local "seen" flag.
function close(): void {
  if (notice.value) void store.markRead(notice.value.id)
}
</script>

<style scoped lang="scss">
.forced-notice {
  color: var(--ds-text);
  overflow-wrap: anywhere;

  button {
    margin-top: 20px;
    padding: 12px 18px;
    width: 100%;
    border: 1px solid var(--ds-border);
    border-radius: var(--ds-radius-control);
    background: transparent;
    color: inherit;
    cursor: pointer;
  }
}
</style>
